import { CheckIcon, CopyIcon } from "@/components/icons";
import { useCopy } from "@/lib/useCopy";
import { cn } from "@/lib/utils";

// DESIGN.md component: code-field. Values always show in full: long ones wrap
// onto more lines, never truncate. The copy action sits inside the field's
// right edge, like the install field on zeroslop.design.
export function CodeField({
  value,
  label,
  prompt,
  className,
}: {
  value: string;
  label: string;
  /** Optional prefix such as "$" for shell commands. Shown, never copied. */
  prompt?: string;
  className?: string;
}) {
  const { copied, copy } = useCopy();

  return (
    <div className={cn("control-border rounded-zsd-sm bg-zsd-surface-sunken flex items-stretch min-w-0", className)}>
      <code
        aria-label={label}
        className="flex-1 min-w-0 px-zsd-md py-zsd-sm min-h-zsd-control-height flex items-center font-zsd-code-md text-zsd-code-md text-zsd-on-surface-sunken text-left whitespace-pre-wrap [overflow-wrap:anywhere]"
      >
        <span>
          {prompt && <span className="text-zsd-muted select-none">{prompt} </span>}
          {value}
        </span>
      </code>
      <button
        type="button"
        onClick={() => copy(value)}
        aria-label={copied ? `${label} copied` : `Copy ${label}`}
        title={copied ? "Copied" : "Copy"}
        className={cn(
          "ease shrink-0 w-zsd-control-height grid place-items-center cursor-pointer rounded-r-zsd-sm",
          "border-l-[length:var(--zsd-x-zsd-border-width-default)] border-l-[var(--zsd-x-zsd-border-color-control)]",
          "hover:bg-zsd-surface-raised",
          copied ? "text-zsd-success" : "text-zsd-on-surface hover:text-zsd-primary",
        )}
      >
        {copied ? <CheckIcon size={16} /> : <CopyIcon size={16} />}
      </button>
    </div>
  );
}
